import {
    ARCHIVE_FILES,
    CREATE_FILE,
    CREATE_FOLDER,
    DELETE_ITEMS,
    DUPLICATE_ITEM,
    EMPTY_DIR,
    RENAME_FILE,
    SAVE_IMAGE,
    UNZIP_FILE,
    UPLOAD_FILES,
    ATTACH_FILES,
    CLEAR_FILES_TOBUFFER,
    COPY_FILES_TOBUFFER,
    CUT_FILES_TOBUFFER,
    GET_FILES_LIST,
    GET_FOLDERS_LIST,
    INVERSE_SELECTED_FILES,
    PASTE_FILES,
    RUN_SORTING_FILTER,
    SELECT_ALL_FILES,
    SET_HISTORY_INDEX,
    SET_IMAGE_SETTINGS,
    SET_ITEM_VIEW,
    SET_SELECTED_FILES,
    SET_SELECTED_FOLDER,
    SET_SORT_ORDER_BY, UNSET_ATTACH_FILES,
    UNSET_SELECTED_FILES
} from "redux/types";

export function setSelectedFiles(item) {
    return {
        item,
        type: SET_SELECTED_FILES
    }
}

export function listViewChange(view) {
    return {
        view,
        type: SET_ITEM_VIEW
    }
}

export function setSorting(orderBy, field) {
    return {
        orderBy,
        field,
        type: SET_SORT_ORDER_BY
    }
}

export function filterSorting() {
    return {
        type: RUN_SORTING_FILTER
    }
}

export function setImagesSettings(imagePreview) {
    return {
        imagePreview,
        type: SET_IMAGE_SETTINGS
    }
}

export function unsetSelectedFiles() {
    return {
        type: UNSET_SELECTED_FILES
    }
}

export function selectAllFiles() {
    return {
        type: SELECT_ALL_FILES
    }
}

export function inverseSelectedFiles() {
    return {
        type: INVERSE_SELECTED_FILES
    }
}

export function copyToBufferFiles() {
    return {
        type: COPY_FILES_TOBUFFER
    }
}

export function cutToBufferFiles() {
    return {
        type: CUT_FILES_TOBUFFER
    }
}

export function clearBufferFiles() {
    return {
        type: CLEAR_FILES_TOBUFFER
    }
}

export function setSelectedFolder(path, history) {
    return {
        type: SET_SELECTED_FOLDER,
        path,
        history
    };
}

export function getFilesList(path) {
    return {
        type: GET_FILES_LIST,
        path: path,
        request: {
            method: 'post',
            url: '/fm/folder'
        },
        body: {
            path
        }
    };
}

export function getFoldersList() {
    return {
        type: GET_FOLDERS_LIST,
        request: {
            method: 'post',
            url: '/fm/foldertree'
        }
    };
}

export function setHistoryIndex(index) {
    return {
        type: SET_HISTORY_INDEX,
        index
    };
}

export function renameFiles(path, newname) {
    return {
        type: RENAME_FILE,
        request: {
            method: 'post',
            url: '/fm/rename'
        },
        body: {
            path,
            newname
        }
    };
}

export function createNewFile(path, file) {
    return {
        type: CREATE_FILE,
        request: {
            method: 'post',
            url: '/fm/createfile'
        },
        body: {
            path,
            file
        }
    };
}

export function createNewFolder(path, folder) {
    return {
        type: CREATE_FOLDER,
        request: {
            method: 'post',
            url: '/fm/createfolder'
        },
        body: {
            path,
            folder
        }
    };
}

export function pasteFiles(items, type, destination) {
    return {
        type: PASTE_FILES,
        request: {
            method: 'post',
            url: type === 'cut' ? '/fm/move' : '/fm/copy'
        },
        body: {
            items,
            destination
        }
    };
}

export function emptyDir(path) {
    return {
        type: EMPTY_DIR,
        request: {
            method: 'post',
            url: '/fm/emptydir'
        },
        body: {
            path
        }
    };
}

export function deleteItems(items) {
    return {
        type: DELETE_ITEMS,
        request: {
            method: 'post',
            url: '/fm/delete'
        },
        body: {
            items
        }
    };
}

export function duplicateItem(path) {
    return {
        type: DUPLICATE_ITEM,
        request: {
            method: 'post',
            url: '/fm/duplicate'
        },
        body: {
            path
        }
    };
}

export function unzip(file, destination) {
    return {
        type: UNZIP_FILE,
        request: {
            method: 'post',
            url: '/fm/unzip'
        },
        body: {
            file,
            destination
        }
    };
}

export function archive(files, destination, name) {
    return {
        type: ARCHIVE_FILES,
        request: {
            method: 'post',
            url: '/fm/archive'
        },
        body: {
            files,
            destination,
            name
        }
    };
}

export function saveImage(file, path, isnew) {
    return {
        type: SAVE_IMAGE,
        request: {
            method: 'post',
            url: '/fm/saveimage'
        },
        body: {
            file,
            path,
            isnew
        }
    };
}

export function uploadFile(body) {
    return {
        type: UPLOAD_FILES,
        request: {
            method: 'post',
            url: '/fm/upload'
        },
        body
    };
}

export function attachedFiles(path) {
    return {
        type: ATTACH_FILES,
        path
    }
}

export function  unsetAttachedFiles(){
    return{
        type: UNSET_ATTACH_FILES
    }
}